import axios, { AxiosError } from "axios";

// Models
import { IPerson } from "../Models/IPerson";

// Constants
import Config from "../Constants/Config";

const BACKEND_URL = process.env.REACT_APP_WEB_API_URL;

export async function AddOrEditPerson(
    aspNetUserId: string,
    payload: IPerson | Partial<IPerson>,
    access_token: string,
    abortController: AbortController
): Promise<true | AxiosError> {
    const url = `${BACKEND_URL}v1/users/${encodeURIComponent(aspNetUserId)}/person`;

    try {
        await axios.put(url, payload, {
            signal: abortController.signal,
            headers: { Authorization: "Bearer " + access_token }
        });
        return true;
    } catch (err) {
        const error = err as AxiosError;
        console.error("AddOrEditPerson error", error);
        return error;
    }
}

export async function GetUserPerson(
    userId: string,
    access_token: string, // <-- Added token parameter
    abortController: AbortController
): Promise<IPerson | null | AxiosError> {
    try {
        const url = `${BACKEND_URL}v1/users/${encodeURIComponent(userId)}/person`;

        const res = await axios.get<IPerson>(url, {
            signal: abortController.signal,
            headers: { Authorization: "Bearer " + access_token } // <-- Added auth header
        });

        return res.data ?? null;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
            if (err.response?.status === 404) return null;
            return err;
        }
        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}

export async function GetIsOnboarded(AspNetUserId: string) {
    const fullUrl = process.env.REACT_APP_API_URL + Config.person + 'GetIsOnboarded/' + AspNetUserId;
    //console.log(fullUrl);
    const response = await axios.get(fullUrl).then((response) => {
        return response.data as boolean;
    }).catch((error: AxiosError) => {
        console.log("GetIsOnboarded error");
        return error;
    });

    return response;
}

